import React from 'react'
import ComponentStyle from '../styles/Components.module.css'

function Slack() {
  return (
    <div className={`${ComponentStyle.title}`}><h1>Slack</h1></div>
  )
}

export default Slack